<template>
    <transition name="fade">
        <div v-if="isShowing" class="root-animation-div">
            <div class="modal-container" v-on:click="close">
                <div class="horizontal">
                    <div class="modal-content" v-on:click.stop>

                        <div class="header">
                            <div class="title">{{l10nThankYouText}}</div>
                            <div class="divider-container">
                                <div class="divider"></div>
                            </div>
                        </div>
                        <div class="body">
                            <div class="message">
                                <jabra-body-text-binding :html="l10nContactMarkup"></jabra-body-text-binding>
                            </div>
                            <div>
                                <form @submit.prevent="handleSubmit" novalidate>
                                    <div class="continue-button-container">
                                        <jabra-btn :type="'submit'" dark>
                                            <div class="submit-button-content-container">
                                                <span>{{l10nContinueToJabrutouchText}}</span>
                                            </div>
                                        </jabra-btn>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    import helpers from '../../services/helpers'

    import {
        SET_THANK_YOU_POPUP_SHOW_STATE,
    } from '../../services/constants'


    export default {
        name: 'jabra-thank-you-popup',
        data: function () {
            return {}
        },
        computed: {
            isShowing() {
                return this.$store.state.thankYouPopup.showState
            },
            l10nContactMarkup() {
                return this.l10nBodyGetter('thank_you_contact_text')
            },
            l10nThankYouText() {
                return this.l10nGetter('thank_you')
            },
            l10nContinueToJabrutouchText() {
                return this.l10nGetter('continue_to_jabrutouch')
            },

        },
        methods: {
            handleSubmit() {
                this.close()
                this.$router.push({name: 'root'})
            },
            close() {
                this.$store.commit(SET_THANK_YOU_POPUP_SHOW_STATE, false)
            },
            l10nBodyGetter(key) {
                return helpers.bodyTextGetter(this.$store, key)
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../../scss/main";

    .root-animation-div {
        position: absolute;
        z-index: 1;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .modal-container {
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(255, 255, 255); /* Fallback color */
        background-color: rgba(255, 255, 255, 0.8); /* Black w/ opacity */
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .horizontal {
        display: flex;
        justify-content: center;
    }

    .modal-content {
        background-color: #fefefe;
        /*margin: 15% auto; !* 15% from the top and centered *!*/
        width: 500px; /* Could be more or less, depending on screen size */
        box-shadow: 0 0 20px 13px $grey-3;
        padding: 100px;
    }

    .title {
        @include font-abraham(50px, $font-color-blue, 400);
        display: flex;
        justify-content: center;
    }

    .divider-container {
        display: flex;
        justify-content: center;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .body {
        @include font-abraham(24px, $font-color-blue, 300);
        padding: 23px;

        .message {
            text-align: center;
            margin: 0 0 15px 0;
        }
        form {
            width: 100%;
        }
    }

    .continue-button-container {
        display: flex;
        justify-content: center;
        padding: 30px;
        div {
            font-size: 20px;
            padding: 7px;
        }
    }

    .submit-button-content-container {
        min-width: 80px;
    }

</style>
